import { useSearchParams } from "react-router-dom";
import { useMemo } from "react";

export type DisplayMode = "popup" | "default";

interface UseDisplayModeResult {
  displayMode: DisplayMode;
  isPopup: boolean;
}

export const useDisplayMode = (): UseDisplayModeResult => {
  const [searchParams] = useSearchParams();

  const displayMode = useMemo(
    (): DisplayMode => (searchParams.get("display") === "popup" ? "popup" : "default"),
    [searchParams]
  );

  return {
    displayMode,
    isPopup: displayMode === "popup",
  };
};
